import $ from "jquery";
import "slick-carousel";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const slider = () => {
    $(".c-sections-customer-voice__list").slick({
        slidesToShow: 2.7,
        slidesToScroll: 2,
        arrows: true,
        nextArrow:
            '<button class="c-sections-customer-voice__next-arrow"></button>',
        infinite: false,
        autoplaySpeed: 3000,
        // variableWidth: true,
        responsive: [
            {
                breakpoint: 1025,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },

            {
                breakpoint: 641,
                settings: {
                    slidesToShow: 1.1,
                    slidesToScroll: 1,
                },
            },
        ],
    });
};

const main = () => {
    const section = document.querySelector(".c-sections-customer-voice");
    if (!section) return;
    slider();
};

export default main;
